var XPortal = XPortal || {};
XPortal.GridCalendar = (function () {
    var self = {};

    self.dictionaryOptions = {};
    self.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    self.SetCalendarOptions = function (options, gridId) {
        var existOptions = self.dictionaryOptions[gridId];
        if (existOptions == undefined) {
            self.dictionaryOptions[gridId] = options;
        }
        else {
            $.extend(existOptions, options);
            self.dictionaryOptions[gridId] = existOptions;
        }

        self.dictionaryOptions[gridId].isFirstLoad = true;
        self.dictionaryOptions[gridId].isHideEmptyParent = false;
    };

    self.ChangeHideEmptyParent = function (grid, value) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        self.dictionaryOptions[gridId].isHideEmptyParent = value;
        var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(XPortal.GridCalendar.GetCurrentView(gridId));
        renderStrategy(grid, true);
    };

    self.GetGridId = function (gridEl) {
        var kgrid = gridEl.data("kendoGrid");
        var id = kgrid.element.attr("data-id");
        return id;
    };

    self.ButtonsPanel = {
        init: function (grid) {
            var $panel = grid.closest('.grid-parent').find('.grid-calendar-buttons-wrapper');
            var $parent = $panel.closest('.grid-action-header');
            var $btn = $parent.find('[data-action="Scheduler"]').first();
            if ($btn.length) {
                $panel.insertAfter($btn);
                $panel.removeClass('d-none');
            }

            $(document).off('click.gridcalendarbuttons').on('click.gridcalendarbuttons', function (e) {
                var $target = $(e.target);
                if ($target.closest('.grid-calendar-buttons-wrapper').length || $target.closest('[data-action="Scheduler"]').length || $target.closest('.k-calendar-container').length) {
                    return;
                }

                var $panels = $('.grid-calendar-buttons-wrapper');
                $panels.removeClass('open');
                setTimeout(function () {
                    $panels.removeClass('right');
                }, 300);
            });
        },
        togglePanel: function ($grid, $btn) {
            var $gridWrp = $grid.closest('.grid-parent');
            var $panel = $gridWrp.find('.grid-calendar-buttons-wrapper');

            var $link = $gridWrp.find('.grid-action-header .dropdown-item:not(.d-none) [data-action="Scheduler"]');
            $panel.insertAfter($link);

            $gridWrp.find('.filters-list-wrapper.open, .columns-list-wrapper.open').removeClass('open');

            XPortal.DropdownBtns.openDotsIfPanelInside($panel);

            setTimeout(function () {
                if (!$panel.hasClass('open')) {
                    $panel.addClass('open');
                    if ($panel.offset().left + $panel.outerWidth() > $(window).width()) {
                        $panel.addClass("right");
                    }
                }
                else {
                    $panel.removeClass('open');
                    setTimeout(function () {
                        $panel.removeClass('right');
                    }, 300);
                }
            }, 50);
        }
    };

    self.InitBaseColumns = function (columns, gridEl) {
        var gridId = XPortal.GridCalendar.GetGridId(gridEl);
        self.dictionaryOptions[gridId].baseColumns = columns;
    };

    self.RefreshGrid = function (grid, commandElement) {
        var action = $(commandElement).attr("data-name");
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        if (!self.dictionaryOptions[gridId]) return;
        var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(action);
        var view = self.dictionaryOptions[gridId].calendarViews.includes(action) ? action : self.dictionaryOptions[gridId].currentView;
        XPortal.GridCalendar.SetCurrentView(view, grid);
        if (renderStrategy) renderStrategy(grid, true);
    };

    self.NavigateToGrid = function (cell, grid) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var startDate = cell.attr("date-start");
        var endDate = cell.attr("date-end");
        var UniqueId = cell.attr("UniqueId");
        var ref = self.dictionaryOptions[gridId].gridLink + "?hshqf=" + self.dictionaryOptions[gridId].calendarNodeId + "~" + startDate + "~" + endDate +
            "~" + self.dictionaryOptions[gridId].gridEntity + "~" + UniqueId;
        return ref;
    };

    self.SetCurrentDate = function (date, grid, gridId) {
        var options = self.dictionaryOptions[gridId];
        if (options == undefined) {
            self.dictionaryOptions[gridId] = {};
        }
        self.dictionaryOptions[gridId].currentDate = date;
        var datepicker = $("#grid-calendar-datepicker-" + grid[0].dataset.id).data("kendoDatePicker");
        datepicker.value(date);
    };

    self.GetCurrentDate = function (gridId) {
        return self.dictionaryOptions[gridId].currentDate;
    };

    self.GetGridCalendarOptions = function (gridId) {
        return self.dictionaryOptions[gridId];
    };

    self.SetCurrentView = function (view, grid) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        self.dictionaryOptions[gridId].currentView = view;
    };

    self.GetCurrentView = function (gridId) {
        return self.dictionaryOptions[gridId].currentView;
    };


    self.GetDataRangeByView = function (gridId) {
        var currentDate = XPortal.GridCalendar.GetCurrentDate(gridId);
        var view = XPortal.GridCalendar.GetCurrentView(gridId);
        switch (view) {
            case 'day':
                return XPortal.Calendar.getDayPeriodTimeZoneAdapted(currentDate);
            case 'week':
                var startDay = self.daysOfWeek.indexOf(self.dictionaryOptions[gridId].startDay);
                return XPortal.Calendar.getWeekPeriodTimeZoneAdapted(currentDate, startDay);
            case 'month':
                return XPortal.Calendar.getMonthPeriodTimeZoneAdapted(currentDate);
            case 'year':
                return XPortal.Calendar.getYearPeriodTimeZoneAdapted(currentDate);
        }
    };

    self.GetDayColumns = function (date, gridId) {
        var columns = [];
        var startTimeOfDay = moment(date).startOf('day')._d;
        var endTimeOfDay = moment(date).endOf('day')._d;
        for (var dt = startTimeOfDay; dt <= endTimeOfDay; dt = moment(dt).add(1, "hours")._d) {
            var startTimeOfHour = moment(dt).startOf('hour')._d;
            var endTimeOfHour = moment(dt).endOf('hour')._d;

            var startHour = moment(dt).startOf('hour').hour();
            var endHour = moment(dt).endOf('hour').hour();
            if (self.dictionaryOptions[gridId].showWorkHours == false) {
                var column = {
                    field: "field" + dt.getHours(), canedit: true, cancreate: true, title: moment(dt).format('h a'), width: 100, locked: false,
                    dateStart: startTimeOfHour, dateEnd: endTimeOfHour, attributes: { 'data-ctype': 'calendarcolumn' }
                }
                columns.push(column);
            }
            else if (startHour >= self.dictionaryOptions[gridId].startDayHour && endHour <= self.dictionaryOptions[gridId].endDayHour) {
                var column = {
                    field: "field" + dt.getHours(), canedit: true, cancreate: true, title: moment(dt).format('h a'), width: 100, locked: false,
                    dateStart: startTimeOfHour, dateEnd: endTimeOfHour, attributes: { 'data-ctype': 'calendarcolumn' }
                }
                columns.push(column);
            }
        }
        return columns;
    };

    self.GetWeekColumns = function (date, gridId) {
        var columns = [];
        var firstDay = moment(date).startOf('week')._d;
        var lastDay = moment(date).endOf('week')._d;
        var startDay = self.daysOfWeek.indexOf(self.dictionaryOptions[gridId].startDay);
        var resultDates = [];
        for (var dt = firstDay; dt <= lastDay; dt = moment(dt).add(1, "days")._d) {
            var day = moment(dt).day();
            if (day >= startDay) {
                resultDates.push(dt);
            }
        }

        firstDay = moment(lastDay).add(1, "days")._d;
        lastDay = moment(lastDay).add(startDay, "days")._d;
        for (var dt = firstDay; dt <= lastDay; dt = moment(dt).add(1, "days")._d) {
            resultDates.push(dt);
        }

        resultDates.forEach(function (dt) {
            var startTimeOfDay = moment(dt).startOf('day')._d;
            var endTimeOfDay = moment(dt).endOf('day')._d;
            var column = {
                field: "field" + dt.getDate(), canedit: true, cancreate: true, title: moment(dt).format('dddd MMM Do'), width: 100, locked: false,
                dateStart: startTimeOfDay, dateEnd: endTimeOfDay, attributes: { 'data-ctype': 'calendarcolumn' }
            }
            columns.push(column);
        });

        return columns;
    };

    self.GetMonthColumns = function (date, gridId) {
        var columns = [];
        if (date != undefined) {
            var firstDay = moment(date).startOf('month')._d;
            var lastDay = moment(date).endOf('month')._d;
            for (var dt = firstDay; dt <= lastDay; dt = moment(dt).add(1, "days")._d) {
                var startTimeOfDay = moment(dt).startOf('day')._d;
                var endTimeOfDay = moment(dt).endOf('day')._d;
                var column = {
                    field: "field" + dt.getDate(), canedit: true, cancreate: true, title: moment(dt).format('Do'), width: 100, locked: false,
                    dateStart: startTimeOfDay, dateEnd: endTimeOfDay, attributes: { 'data-ctype': 'calendarcolumn' }
                }
                columns.push(column);
            }
            return columns;
        }
    };

    self.GetYearColumns = function (date, gridId) {
        var year = date.getFullYear();
        var firstDay = moment(date).startOf('year')._d;
        var lastDay = moment(date).endOf('year')._d;
        var extendColumns = [];
        for (var dt = firstDay; dt <= lastDay; dt = moment(dt).add(1, "months")._d) {
            var firstDayOfMonth = moment(dt).startOf('month')._d;
            var lastDayOfMonth = moment(dt).endOf('month')._d;
            extendColumns.push({
                field: "field" + dt.getMonth(), canedit: true, cancreate: true, title: moment(dt).format('MMMM YYYY'), width: 100, locked: false,
                dateStart: firstDayOfMonth, dateEnd: lastDayOfMonth, attributes: { 'data-ctype': 'calendarcolumn' }
            });
        }
        return extendColumns;
    };

    self.DayRenderStrategy = function (grid, isUpdateOptions) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var currentDate = self.dictionaryOptions[gridId].currentDate;
        var dayColumns = XPortal.GridCalendar.GetDayColumns(currentDate, gridId);
        self.dictionaryOptions[gridId].baseColumns = self.dictionaryOptions[gridId].baseColumns.filter(function (item) {
            return item.attributes["data-ctype"] != "calendarcolumn";
        });
        var gridColumns = self.dictionaryOptions[gridId].baseColumns.concat(dayColumns);
        XPortal.GridCalendar.UpdateGridColumns(grid, gridColumns, isUpdateOptions);
    };

    self.WeekRenderStrategy = function (grid, isUpdateOptions) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var currentDate = self.dictionaryOptions[gridId].currentDate;
        var weekColumns = XPortal.GridCalendar.GetWeekColumns(currentDate, gridId);
        self.dictionaryOptions[gridId].baseColumns = self.dictionaryOptions[gridId].baseColumns.filter(function (item) {
            return item.attributes["data-ctype"] != "calendarcolumn";
        });
        var gridColumns = self.dictionaryOptions[gridId].baseColumns.concat(weekColumns);
        XPortal.GridCalendar.UpdateGridColumns(grid, gridColumns, isUpdateOptions);

    };

    self.MonthRenderStrategy = function (grid, isUpdateOptions) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var currentDate = self.dictionaryOptions[gridId].currentDate;
        var monthColumns = XPortal.GridCalendar.GetMonthColumns(currentDate, gridId);
        self.dictionaryOptions[gridId].baseColumns = self.dictionaryOptions[gridId].baseColumns.filter(function (item) {
            return item.attributes["data-ctype"] != "calendarcolumn";
        });
        var gridColumns = self.dictionaryOptions[gridId].baseColumns.concat(monthColumns);
        XPortal.GridCalendar.UpdateGridColumns(grid, gridColumns, isUpdateOptions);
    };

    self.YearRenderStrategy = function (grid, isUpdateOptions) {
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var currentDate = self.dictionaryOptions[gridId].currentDate;
        var yearColumns = XPortal.GridCalendar.GetYearColumns(currentDate, gridId);
        self.dictionaryOptions[gridId].baseColumns = self.dictionaryOptions[gridId].baseColumns.filter(function (item) {
            return item.attributes["data-ctype"] != "calendarcolumn";
        });
        var gridColumns = self.dictionaryOptions[gridId].baseColumns.concat(yearColumns);
        XPortal.GridCalendar.UpdateGridColumns(grid, gridColumns, isUpdateOptions);
    };

    self.TodayRenderStrategy = function (grid) {
        var currentDate = new Date();
        var id = XPortal.GridCalendar.GetGridId(grid);
        XPortal.GridCalendar.SetCurrentDate(currentDate, grid, id);
        var view = XPortal.GridCalendar.GetCurrentView(id);
        var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(view);
        renderStrategy(grid, true);
    };

    self.PreviousRenderStrategy = function (grid) {
        var id = XPortal.GridCalendar.GetGridId(grid);
        var view = XPortal.GridCalendar.GetCurrentView(id);
        var currentDate = XPortal.GridCalendar.GetCurrentDate(id);
        var dateKey = view + "s";
        var newDate = moment(currentDate).add(-1, dateKey);
        XPortal.GridCalendar.SetCurrentDate(newDate._d, grid, id);
        var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(view);
        renderStrategy(grid, true);
    };

    self.NextRenderStrategy = function (grid) {
        var id = XPortal.GridCalendar.GetGridId(grid);
        var view = XPortal.GridCalendar.GetCurrentView(id);
        var currentDate = XPortal.GridCalendar.GetCurrentDate(id);
        var dateKey = view + "s";
        var newDate = moment(currentDate).add(1, dateKey);
        XPortal.GridCalendar.SetCurrentDate(newDate._d, grid, id);
        var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(view);
        renderStrategy(grid, true);
    };

    self.UpdateGridColumns = function (grid, columns, isUpdateOptions) {
        var gridData = grid.data("kendoGrid");
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        if (isUpdateOptions || self.dictionaryOptions[gridId].isFirstLoad) {
            var options = gridData.getOptions();
            options.columns = columns;
            gridData.setOptions(options);
            self.dictionaryOptions[gridId].isFirstLoad = false;
        }
        XPortal.GridCalendar.ColorGridCells(grid, columns);

        var elems = document.getElementsByClassName("k-link h-100");
        var id = XPortal.GridCalendar.GetGridId(grid);
        var view = XPortal.GridCalendar.GetCurrentView(id);
        for (let element of elems) {
            var action = $(element).attr("data-name");
            if (action == view) {
                $(element).addClass("k-state-selected");
            }
        }
    };

    self.ColorGridCells = function (grid, columns) {
        var gridData = grid.data("kendoGrid");
        var gridId = XPortal.GridCalendar.GetGridId(grid);
        var gridItems = XPortal.GridCalendar.CreateChilds(gridData.dataSource.data(), gridId);
        var rows = $("[role=grid]")[1].rows;

        var gridLockCell = grid.find(".k-grid-content-locked table tbody tr td[role='gridcell']");
        XPortal.GridCalendar.RenderCalendarData(gridItems, columns, rows, gridLockCell);
    };

    self.RenderCalendarData = function (gridItems, columns, rows, gridLockCell) {
        rows = $(rows).filter("[class!='k-grouping-row']");

        var sortGridItems = [];
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var itemId = $(row).attr("data-uid");
            var gridItem = gridItems.find(x => x.uid === itemId);
            sortGridItems.push(gridItem);
        }

        gridItems = sortGridItems;

        var template = kendo.template($("#cell-template").html());
        var groupTemplate = kendo.template($("#cell-group-template").html());
        for (var i = 0; i < columns.length; i++) {
            var column = columns[i];
            if (column.dateStart != undefined && column.dateEnd != undefined) {
                for (var j = 0; j < rows.length; j++) {
                    var item = gridItems[j];
                    if (item == undefined)
                        continue;
                    var childItems = item.childItems;
                    if (childItems != undefined && childItems.length > 0) {
                        var itemsInColumn = XPortal.GridCalendar.DateRangeArayOverlaps(childItems, column.dateStart, column.dateEnd);
                        var offset = gridLockCell.length / rows.length;
                        if (itemsInColumn.length > 1) {
                            var cell = $(rows[j].cells[i - offset]);
                            cell.addClass('scheduler-cell');
                            cell.attr('date-start', column.dateStart.toUTCString());
                            var dateEnd = moment(column.dateEnd).add(1, 'seconds');
                            cell.attr('date-end', dateEnd._d.toUTCString());
                            cell.attr('UniqueId', item.UniqueId);
                            var groupItem = itemsInColumn[0];
                            groupItem.dataArray = itemsInColumn;
                            cell[0].innerHTML = groupTemplate(groupItem);
                            cell.find(".k-event-block").addClass('group');
                        }
                        else if (itemsInColumn.length == 1) {
                            var childItem = itemsInColumn[0];
                            var cell = $(rows[j].cells[i - offset]);
                            cell.addClass('scheduler-cell');
                            cell.attr('date-start', column.dateStart.toUTCString());
                            var dateEnd = moment(column.dateEnd).add(1, 'seconds');
                            cell.attr('date-end', dateEnd._d.toUTCString());
                            cell.attr('data-uid', childItem.UniqueId);
                            cell[0].innerHTML = template(childItem);
                        }
                    }
                }
            }
            else {
                for (var k = 0; k < rows.length; k++) {
                    var celld = rows[k].cells[i];
                    if (celld != undefined) {
                        celld.innerHTML = XPortal.Grid.WrapCellContent(celld.innerHTML);
                    }
                }
            }
        }
    };

    self.CreateChilds = function (items, gridId) {
        var options;
        var calendarData = self.dictionaryOptions[gridId].calendarData;
        var calendarDataDictionary = self.dictionaryOptions[gridId].calendarDataDictionary;

        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var childs = calendarDataDictionary[item.UniqueId];
            items[i].childItems = childs;
        }

        return items;
    };

    self.DateRangeOverlaps = function (startItem, endItem, startColumn, endColumn) {
        if ((startItem < endColumn) && (endItem > startColumn)) {
            var obj = {};
            obj.startDate = startItem <= startColumn ? startColumn : startItem;
            obj.endDate = endItem <= endColumn ? endItem : endColumn;

            return obj;
        }
        else return null;
    };

    self.DateRangeArayOverlaps = function (itemsArray, startColumn, endColumn) {
        var result = [];
        for (i = 0; i < itemsArray.length; i++) {
            item = itemsArray[i];
            if (XPortal.GridCalendar.DateRangeOverlaps(item.start, item.end, startColumn, endColumn)) {
                result.push(item);
            }
        }
        return result;
    };

    self.ResolveRenderStrategy = function (calendarAction) {
        switch (calendarAction) {
            case 'day':
                return XPortal.GridCalendar.DayRenderStrategy;
            case 'week':
                return XPortal.GridCalendar.WeekRenderStrategy;
            case 'month':
                return XPortal.GridCalendar.MonthRenderStrategy;
            case 'year':
                return XPortal.GridCalendar.YearRenderStrategy;
            case 'today':
                return XPortal.GridCalendar.TodayRenderStrategy;
            case 'previous':
                return XPortal.GridCalendar.PreviousRenderStrategy;
            case 'next':
                return XPortal.GridCalendar.NextRenderStrategy;
        }
    };

    self.ResolveColumnStrategy = function (view) {
        switch (view) {
            case 'day':
                return XPortal.GridCalendar.GetDayColumns;
            case 'week':
                return XPortal.GridCalendar.GetWeekColumns;
            case 'month':
                return XPortal.GridCalendar.GetMonthColumns;
            case 'year':
                return XPortal.GridCalendar.GetYearColumns;
        }
    };

    self.InitChildEntity = function (grid, data, gridId, pageIndex) {
        if (self.dictionaryOptions[gridId].isExtendedGrid == false) return;
        var url = grid.attr("data-calendar-url");
        var options;
        var gridData = !(data.Result) ? [] : data.Result.Items.map(di => XPortal.Grid.MapEntity(di, options));
        var ids = gridData.map(a => a.UniqueId);
        var range = XPortal.GridCalendar.GetDataRangeByView(gridId);

        var postData = {
            model: {
                EntityAlias: self.dictionaryOptions[gridId].calendarEntity,
                NodeId: self.dictionaryOptions[gridId].calendarNodeId,
                PageIndex: (pageIndex == undefined) ? 1 : pageIndex,
                PageSize: 10000000,
                ElementIds: ids,
                ParentNodeId: self.dictionaryOptions[gridId].nodeId,
                Filter: {
                    Filters: [
                        { value: range.end, operator: "lte", field: self.dictionaryOptions[gridId].bindField.toLowerCase() },
                        { value: range.start, operator: "gte", field: self.dictionaryOptions[gridId].endDateField.toLowerCase() }
                    ],
                    Logic: "and"
                }
            }
        };

        jQuery.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: postData,
            success: function (xdata) {
                var options;
                var calendarArray = [];
                var parentIds = [];
                for (var key in xdata.Childs) {
                    var childArray = xdata.Childs[key];
                    parentIds.push(key);
                    calendarArray = calendarArray.concat(childArray);
                }
                self.dictionaryOptions[gridId].parentIds = parentIds;
                self.dictionaryOptions[gridId].calendarData = XPortal.GridCalendar.ExtendCalendarData(!(xdata.Result) ? [] : xdata.Result.Items.map(di => XPortal.Grid.MapEntity(di, options)), xdata.Childs, gridId);
                self.dictionaryOptions[gridId].calendarDataDictionary = xdata.Childs;
                var id = XPortal.GridCalendar.GetGridId(grid);
                var renderStrategy = XPortal.GridCalendar.ResolveRenderStrategy(XPortal.GridCalendar.GetCurrentView(id));
                renderStrategy(grid, false);
                if (grid.hasClass('entity-grid-calendar') && !grid.hasClass('entity-grid-calendar-inited')) {
                    setTimeout(function () {
                        XPortal.Grid.ShowGrid(grid);
                        grid.addClass('entity-grid-calendar-inited');
                    }, 200);
                }

                rows = $($("[role=grid]")[1].rows).filter("[class!='k-grouping-row']");

                for (var j = 0; j < rows.length; j++) {
                    var row = rows[j];
                    row.onclick = function (e) {
                        var element = $(e.target).is(".k-event-block") ? $(e.target) : $(e.target).closest(".k-event-block");

                        if (element.length > 0) {
                            var isPrimaryBtn = $(e.target).is(".btn-primary")
                            if ($(e.target.parentNode).is("td") || $(e.target.parentNode).is(".movie-template")) {
                                if (isPrimaryBtn == false) {
                                    var parentElement = $(e.target.parentNode).is("td") ? $(e.target.parentNode) : $(e.target.parentNode).closest("td");
                                    if (parentElement.length > 0) {
                                        if (parentElement.hasClass("active")) {
                                            $(parentElement).removeClass("active");
                                        }
                                        else {
                                            $(parentElement).addClass("active");
                                        }
                                    }
                                    e.stopPropagation();
                                }
                            }
                        }

                        else if (e.target.attributes["data-ctype"] !== undefined && e.target.attributes["data-ctype"].nodeValue == "calendarcolumn") {
                            e.stopPropagation();
                        }
                    }
                }
            }
        });
    };


    self.GetParentIds = function (grid, data, gridId, pageIndex) {
        var url = grid.attr("data-calendar-url");
        var options;
        var gridData = !(data.Result) ? [] : data.Result.Items.map(di => XPortal.Grid.MapEntity(di, options));
        var ids = gridData.map(a => a.UniqueId);
        var range = XPortal.GridCalendar.GetDataRangeByView(gridId);

        var postData = {
            model: {
                EntityAlias: self.dictionaryOptions[gridId].calendarEntity,
                NodeId: self.dictionaryOptions[gridId].calendarNodeId,
                PageIndex: (pageIndex == undefined) ? 1 : pageIndex,
                PageSize: 10000000,
                ElementIds: ids,
                ParentNodeId: self.dictionaryOptions[gridId].nodeId,
                Filter: {
                    Filters: [
                        { value: range.end, operator: "lte", field: self.dictionaryOptions[gridId].bindField.toLowerCase() },
                        { value: range.start, operator: "gte", field: self.dictionaryOptions[gridId].endDateField.toLowerCase() }
                    ],
                    Logic: "and"
                }
            }
        };

        return $.ajax({
            url: url,
            type: 'POST',
            dataType: 'json',
            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
            data: postData
        });
    };

    self.ExtendCalendarData = function (data, groppedData, gridId) {

        var result = [];
        var dictionaryLength = Object.keys(groppedData).length;
        var colors = XPortal.GridCalendar.GetColors(dictionaryLength, gridId);
        var keys = Object.keys(groppedData);

        var i = 0;
        keys.forEach(function (key) {
            var options;
            var childArray = groppedData[key];
            childArray.map(di => XPortal.Grid.MapEntity(di, options));
            for (j = 0; j < childArray.length; j++) {
                childArray[j].color = colors[i];
                childArray[j].href = self.dictionaryOptions[gridId].detailGridLink + "?id=" + childArray[j].UniqueId +
                    "&r=" + XPortal.Utils.guid() + "&bc=" + self.dictionaryOptions[gridId].calendarNodeId;
                childArray[j].start = childArray[j][self.dictionaryOptions[gridId].bindField.toLowerCase()];
                childArray[j].end = childArray[j][self.dictionaryOptions[gridId].endDateField.toLowerCase()];
                childArray[j] = XPortal.Calendar.changeDateFormat(childArray[j], self.dictionaryOptions[gridId].dateFormat);
            }

            for (j = 0; j < childArray.length; j++) {
                var item = childArray[j];
                var exist = result.find(a => a.UniqueId === item.UniqueId);
                if (exist == undefined) {
                    result.push(item);
                }
            }
            i++;
        });

        return result;
    };

    self.GetCalendarItemById = function (uid, gridId) {
        return self.dictionaryOptions[gridId].calendarData.find(a => a.UniqueId === uid);
    };

    self.GetColors = function (count, gridId) {
        var result = [];
        if (self.dictionaryOptions[gridId].colors === null) return [];
        var iterator = self.dictionaryOptions[gridId].colors.values();
        for (i = 0; i < count; i++) {
            var color = iterator.next();
            if (color.value !== undefined) result.push(color.value);
            else {
                iterator = self.dictionaryOptions[gridId].colors.values();
                color = iterator.next().value;
                result.push(color);
            }
        }
        return result;
    };

    return self;
}());